import axios from "axios";
import { myApi } from "../../../constants/consts";

export const messagesService = {
  async getMessages(supportId) {
    const res = await axios.get(`${myApi}/get_message`, {
      params: { supportId },
    });
    return res.data;
  },

  async addMessage({
    supportId,
    senderId,
    receiverId,
    message,
    senderName,
    userType = "user",
    type,
  }) {
    const res = await axios.post(`${myApi}/add_message`, {
      support_id: supportId,
      sender_id: senderId,
      receiver_id: receiverId,
      message,
      sender_name: senderName,
      user_type: userType,
      type,
    });
    return res.data;
  },

  async updateUnread({ unread, supportId, type }) {
    const res = await axios.post(`${myApi}/update_unread`, {
      unread,
      supportId,
      type,
    });
    return res.data;
  },

  async uploadFile(file, sunucuKodu, dosyaType) {
    const formData = new FormData();
    formData.append("myfile", file);
    formData.append("sunucukodu", sunucuKodu);
    formData.append("dosyaType", dosyaType);
    const res = await axios.post(`${myApi}/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  async checkDataIsUpdated({ target = "user", userId, root = "msg" }) {
    const res = await axios.post(`${myApi}/check_data_is_updated`, {
      target,
      user_id: Number(userId),
      root,
    });
    return res.data?.data === true;
  },

  async changeUpdateValue({ target, newValue, userId, root = "msg" }) {
    const res = await axios.post(`${myApi}/change_status_update_value`, {
      target,
      new_value: newValue,
      user_id: userId,
      root,
    });
    return res.data;
  },

  // ← YENİ: destekçi tarafı sunucu kodunu bulmak için
  async getUserById(userId) {
    const res = await axios.get(`${myApi}/get_user_by_id`, {
      params: { user_id: userId },
    });
    const user = Array.isArray(res.data) ? res.data[0] : res.data;
    return user || null;
  },
};
